import React from "react";
import { ThreeDots } from "react-loader-spinner";

const Loader = () => {
	return <ThreeDots color='#207891' height='100' width='100' />;
};

export default Loader;
